
// import React, { useState, useEffect, useRef } from 'react';
// import { MapContainer, TileLayer, GeoJSON, Marker, useMap, } from 'react-leaflet';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import domtoimage from 'dom-to-image';
// import { jsPDF } from 'jspdf';
// import autoTable from 'jspdf-autotable';
// import { FaCircleInfo } from "react-icons/fa6";


// // Risk data for municipalities
// const riskData = {
//   'TL01': { probability: 0.6, riskLevel: 'High Risk' },
//   'TL02': { probability: 0.7, riskLevel: 'High Risk' },
//   'TL03': { probability: 0.3, riskLevel: 'Moderate Risk' },
//   'TL04': { probability: 0.4, riskLevel: 'Moderate Risk' },
//   'TL05': { probability: 0.35, riskLevel: 'Moderate Risk' },
//   'TL06': { probability: 0.1, riskLevel: 'Low Risk' },
//   'TL07': { probability: 0.15, riskLevel: 'Low Risk' },
//   'TL08': { probability: 0.1, riskLevel: 'Low Risk' },
//   'TL09': { probability: 0.05, riskLevel: 'Low Risk' },
//   'TL10': { probability: 0.1, riskLevel: 'Low Risk' },
//   'TL11': { probability: 0.15, riskLevel: 'Low Risk' },
//   'TL12': { probability: 0.2, riskLevel: 'Low Risk' },
//   'TL13': { probability: 0.85, riskLevel: 'Very High Risk' },
//   'TL14': { probability: 0.1, riskLevel: 'Low Risk' },
// };


// const getColor = (probability) => {
//   if (probability >= 0.8) return 'rgb(232, 19, 36)'; // Very High Risk (Red)
//   if (probability >= 0.5) return 'rgb(246, 99, 12)'; // High Risk (Orange)
//   if (probability >= 0.2) return 'rgb(255, 240, 0)'; // Moderate Risk (Yellow)
//   return 'rgb(22, 198, 9)'; // Low Risk (Green)
// };


// const translations = {
//   en: {
//     title: 'DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM',
//     warningTitle: 'Lightning Advisory for Timor Leste',
//     advisoryNumber: 'Advisory number: ',
//     issuedBy: 'Issued by:',
//     issuedAt: 'Date & Time:',
//     overview: 'Overview',
//     highRiskWarningPart1: 'A forecast has been issued for the likelihood of a moderate to severe lightning flash at several places in Aileu, Ainaro, Oecusse.',
//     moderateRiskWarning: 'Moderate risk of lightning activity is expected in [moderateRiskAreas].',
//     highRiskWarningPart2: 'There may be temporary localized strong winds during thundershowers. The general public is kindly requested to take adequate precautions to minimize damages caused by lightning activity.',
//     mapHeading: 'Lightning Flash Probability Map',
//     tableHeaders: ['Municipality', 'Impact', 'Probability'],
//     generalAdvisory: 'General Advisory',
//     advisoryIntro: 'The Disaster Risk Reduction Decision Support System advises the following precautions to ensure safety and mitigate lightning risks:',
//     advisoryTableHeaders: ['Type', 'Advisory'],
//     advisoryPoints: [
//       {
//         type: 'Shelter',
//         points: [
//           'Seek shelter, preferably indoors and never under trees.'
//         ]
//       },
//       {
//         type: 'Avoid Open Areas',
//         points: [
//           'Avoid open areas such as paddy fields, plantations, and open water bodies during thunderstorms.'
//         ]
//       },
//       {
//         type: 'Electrical Safety',
//         points: [
//           'Avoid using wired telephones and connected electric appliances during thunderstorms.'
//         ]
//       },
//       {
//         type: 'Vehicle Safety',
//         points: [
//           'Avoid using open vehicles, such as bicycles, tractors, and boats.'
//         ]
//       },
//       {
//         type: 'Environmental Hazards',
//         points: [
//           'Beware of fallen trees and power lines.'
//         ]
//       },
//       {
//         type: 'Emergency Assistance',
//         points: [
//           'For emergency assistance, contact the local disaster management authorities.'
//         ]
//       }
//     ],
//     noteLabel: 'Note:',
//     noteText: 'The report is valid for Date-Time. Please monitor the website for additional information and alerts issued by the Department of Meteorology.',
//     footer: 'DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986',
//     page: 'Page [i] of [pageCount]'
//   },
//   tetum: {
//     title: 'SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE',
//     warningTitle: 'Aviso Kona-ba Rai-hukar iha Timor-Leste',
//     advisoryNumber: 'Númeru Aviso:',
//     issuedBy: 'Ema-husik husi:',
//     issuedAt: 'Data no Oras:',
//     overview: 'Visaun Jeral',
//     highRiskWarningPart1: 'Forescast ida ema-husik ona kona-ba possibilidade rai-hukar moderadu to forte iha fatin barak iha Aileu, Ainaro, Oecusse.',
//     moderateRiskWarning: 'Risku moderadu kona-ba atividade rai-hukar espera iha [moderateRiskAreas].',
//     highRiskWarningPart2: 'Bele iha ventu forte lokal temporariu durante rai-hukar. Públiku jeral husu atu halo prevensaun adekuadu hodi minimiza estragu sira ne’ebé rai-hukar bele kauza.',
//     mapHeading: 'Mapa Probabilidade Rai-Hukar',
//     tableHeaders: ['Munisípiu', 'Impaktu', 'Probabilidade'],
//     generalAdvisory: 'Konsellu Jeral',
//     advisoryIntro: 'Sistema Apoiu Desizaun Redusaun Risku Dezastre konsella medida prevensaun tuir mai atu garante seguransa no mitiga risku rai-hukar:',
//     advisoryTableHeaders: ['Tipu', 'Konsellu'],
//     advisoryPoints: [
//       {
//         type: 'Abrigu',
//         points: [
//           'Buka fatin abrigadu, preferensialmente iha laran uma no nunka iha ai-hun okos.'
//         ]
//       },
//       {
//         type: 'Evita Fatin Abertu',
//         points: [
//           'Evita fatin abertu hanesan to’os, plantasaun, no tasi ibun sira durante rai-hukar.'
//         ]
//       },
//       {
//         type: 'Seguransa Eletrika',
//         points: [
//           'Evita uza telefoni ho kabu no aparelhu eletrisidade ne’ebé konektadu durante rai-hukar.'
//         ]
//       },
//       {
//         type: 'Seguransa Veíkulu',
//         points: [
//           'Evita uza veíkulu abertu, hanesan bisikleta, trator, no ro.'
//         ]
//       },
//       {
//         type: 'Perigu Ambiental',
//         points: [
//           'Kuidadu ho ai-hun ne’ebé monu no liña eletrika.'
//         ]
//       },
//       {
//         type: 'Asisténsia Emerjénsia',
//         points: [
//           'Ba asisténsia emerjénsia, kontaktu autoridade jestaun dezastre lokál.'
//         ]
//       }
//     ],
//     noteLabel: 'Nota:',
//     noteText: 'Relatóriu ne’e válidu ba oras 24 oin. Favor monitoriza website ba informasaun adisional no alerta sira ne’ebé Departamentu Meteorolojia ema-husik.',
//     footer: 'SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE (DRRDSS), Email: timor-leste@rimes.int, Telefone: +670-74520986',
//     page: 'Pajina [i] husi [pageCount]'
//   }
// };

// // Risk level translations
// const riskLevelTranslations = {
//   en: {
//     'Very High Risk': 'Very High Risk',
//     'High Risk': 'High Risk',
//     'Moderate Risk': 'Moderate Risk'
//   },
//   tetum: {
//     'Very High Risk': 'Risku Altamente Altus',
//     'High Risk': 'Risku Altus',
//     'Moderate Risk': 'Risku Moderadu'
//   }
// };

// // Helper function to load images
// const loadImage = (src) => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     img.crossOrigin = 'Anonymous';
//     img.onload = () => resolve(img);
//     img.onerror = reject;
//     img.src = src;
//   });
// };

// // Helper function to add banner to a page
// const addBanner = (pdf, bannerImage, sideMargin, topMargin, pageWidth) => {
//   const bannerHeight = 20; // Height in mm
//   const bannerWidth = pageWidth - 2 * sideMargin; // Span page width minus margins
//   if (bannerImage) {
//     pdf.addImage(
//       bannerImage,
//       'PNG',
//       sideMargin,
//       topMargin,
//       bannerWidth,
//       bannerHeight
//     );
//   }
//   return topMargin + bannerHeight + 5; // Return new currentY (5mm gap)
// };

// // PDF generation with language support
// const generatePdfWithImage = async (dataUrl, geoData, language = 'en') => {
//   try {
//     const pdf = new jsPDF('portrait', 'mm', 'a4');
//     const pageWidth = pdf.internal.pageSize.getWidth(); // 210 mm
//     const pageHeight = pdf.internal.pageSize.getHeight(); // 297 mm
//     const sideMargin = 10;
//     const topMargin = 10;
//     const footerHeight = 10;
//     const marginBottom = 10;
//     const bannerHeight = 20; // Assumed banner height
//     const headerHeight = topMargin + bannerHeight + 5; // 35 mm (10 + 20 + 5)
//     const availablePageHeight = pageHeight - headerHeight - footerHeight - marginBottom; // ~242 mm
//     let currentY;

//     const t = translations[language];
//     const riskT = riskLevelTranslations[language];

//     // Load banner image based on language
//     let bannerImage;
//     const bannerPath = language === 'en' ? '/pdf/banner.png' : '/pdf/tetumbanner.png';
//     try {
//       bannerImage = await loadImage(bannerPath);
//     } catch (error) {
//       console.warn(`Failed to load ${bannerPath}:`, error);
//       bannerImage = null;
//     }


//     // Helper function to add page with header
//     const addPageWithHeader = () => {
//       pdf.addPage();
//       return addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//     };

//     // Add banner to first page
//     currentY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//     currentY += 5;

  
//         // Add warning title
//     pdf.setFont('helvetica','bold');
//     pdf.setFontSize(14);
//     pdf.setTextColor(0, 0, 0);
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.text(t.warningTitle, pageWidth / 2, currentY, { align: "center"});
//     pdf.setFont('normal');
//     pdf.setTextColor(0, 0, 0);
//     currentY += 10;

//     // Format date in Asia/Dili timezone
//     const now = new Date();
//     const formattedDate = new Intl.DateTimeFormat("en-GB", {
//       timeZone: "Asia/Dili",
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     }).format(now);

//     const [datePart, timePartRaw] = formattedDate.split(", ");
//     const [day, month, year] = datePart.split("/");
//     const timeMatch = timePartRaw.match(/(\d{2}):(\d{2}):(\d{2})\s?(AM|PM)/i);
//     const [hour, minute, second, period] = timeMatch;
//     const formattedTimorDate = `${year}-${month}-${day} ${hour}:${minute}:${second} ${period.toUpperCase()} East Timor Time (TLT)`;

//     // Set font for advisory details
//     // pdf.setFontSize(10);
//     // pdf.setFont("helvetica", "normal");

//     // // Ensure enough space, else add page
//     // if (currentY + 6 > availablePageHeight + headerHeight) {
//     //   currentY = addPageWithHeader();
//     // }

//     // // Prepare left and right text
//     // const leftText = `${t.advisoryNumber} 1`;
//     // const rightText = `${t.issuedAt} ${formattedTimorDate}`;

//     // // Measure width of right text to align it from the right edge
//     // const rightTextWidth = pdf.getTextWidth(rightText);
//     // const rightX = pageWidth - sideMargin - rightTextWidth;

//     // // Print both texts on the same line
//     // pdf.text(leftText, sideMargin, currentY);
//     // pdf.text(rightText, rightX, currentY);
//     // currentY += 6;

//     // // Check for space and print "issued by"
//     // if (currentY + 6 > availablePageHeight + headerHeight) {
//     //   currentY = addPageWithHeader();
//     // }
//     // pdf.text(`${t.issuedBy} Department of Meteorology`, sideMargin, currentY);
//     // currentY += 6;

//     // currentY += 5;

//      pdf.setFontSize(10);

//     // Ensure enough space, else add page
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }

//     // Prepare left and right text with bold labels
//     pdf.setFont('helvetica', 'bold');
//     const advisoryNumberLabel = t.advisoryNumber;
//     pdf.text(advisoryNumberLabel, sideMargin, currentY);
//     pdf.setFont('helvetica', 'normal');
//     pdf.text(' 1', sideMargin + pdf.getTextWidth(advisoryNumberLabel) + 2, currentY);
//     pdf.setFont('helvetica', 'bold');
//     const issuedAtLabel = t.issuedAt;
//     const rightText = `${issuedAtLabel} ${formattedTimorDate}`;
//     const rightTextWidth = pdf.getTextWidth(rightText);
//     const rightX = pageWidth - sideMargin - rightTextWidth;
//     pdf.text(issuedAtLabel, rightX, currentY);
//     pdf.setFont('helvetica', 'normal');
//     pdf.text(formattedTimorDate, rightX + pdf.getTextWidth(issuedAtLabel) + 2, currentY);
//     currentY += 6;

//     // Issued by
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFont('helvetica','bold');
//     const issuedByLabel = t.issuedBy;
//     pdf.text(issuedByLabel, sideMargin, currentY);
//     pdf.setFont('helvetica','normal');
//     pdf.text('National Directorate of Meteorology and Geophysics', sideMargin + pdf.getTextWidth(issuedByLabel) + 2, currentY);
//     currentY += 6;

//     currentY += 5;

//     // Identify high-risk and moderate-risk municipalities
//     // const highRiskMunicipalities = Object.entries(riskData)
//     //   .filter(([_, data]) => data.probability >= 0.5)
//     //   .map(([code, _]) => {
//     //     const feature = geoData?.features.find(
//     //       (f) => f.properties.ADM_Code === code
//     //     );
//     //     return feature?.properties.ADM1 || code;
//     //   });
//     // const affectedAreas = highRiskMunicipalities.length > 0
//     //   ? highRiskMunicipalities.join(', ')
//     //   : language === 'en' ? 'No high-risk areas identified' : 'Laiha fatin ho risku altus identifika';

//     const moderateRiskMunicipalities = Object.entries(riskData)
//       .filter(([_, data]) => data.probability >= 0.3 && data.probability < 0.5)
//       .map(([code, _]) => {
//         const feature = geoData?.features.find(
//           (f) => f.properties.ADM_Code === code
//         );
//         return feature?.properties.ADM1 || code;
//       });
//     const moderateRiskAreas = moderateRiskMunicipalities.length > 0
//       ? moderateRiskMunicipalities.join(', ')
//       : language === 'en' ? 'No moderate-risk areas identified' : 'Laiha fatin ho risku moderadu identifika';

    
//       currentY += 5;

//     // OVERVIEW section
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont('helvetica', 'bold');
//     pdf.setFillColor(202, 217, 239); // Light blue background
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, 'F');
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(t.overview, sideMargin + 2, currentY - 2, { align: 'left' });
//     pdf.setTextColor(0, 0, 0);
//     currentY += 10;

//     // Warning messages
//     pdf.setFontSize(10);
//     pdf.setFont('helvetica', 'normal');
//     const warningText = [
//       t.highRiskWarningPart1,
//       t.moderateRiskWarning.replace('[moderateRiskAreas]', moderateRiskAreas),
//       t.highRiskWarningPart2
//     ];
//     warningText.forEach(line => {
//       const lines = pdf.splitTextToSize(line, pageWidth - 2 * sideMargin);
//       lines.forEach(splitLine => {
//         if (currentY + 6 > availablePageHeight + headerHeight) {
//           currentY = addPageWithHeader();
//         }
//         pdf.text(splitLine, sideMargin, currentY);
//         currentY += 6;
//       });
//       currentY += 2;
//     });
//     currentY += 5;

//     // MAP heading
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont('helvetica', 'bold');
//     pdf.setFillColor(202, 217, 239);
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, 'F');
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(t.mapHeading, sideMargin + 2, currentY - 2, { align: 'left' });
//     pdf.setTextColor(0, 0, 0);
//     currentY += 5;

//     // Add map image
//     if (dataUrl) {
//       const img = await loadImage(dataUrl);
//       const availableWidth = pageWidth - 2 * sideMargin;
//       const imgHeight = (img.height * availableWidth) / img.width;
//       if (currentY + imgHeight + 5 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }
//       pdf.addImage(dataUrl, 'PNG', sideMargin, currentY, availableWidth, imgHeight);
//       currentY += imgHeight + 5;
//     } else {
//       console.warn('No map image provided for PDF');
//     }
//     currentY += 5;

//     // Prepare table data
//     const tableData = Object.entries(riskData)
//       .filter(([_, data]) => data.probability >= 0.3)
//       .map(([code, data]) => {
//         const municipality = geoData?.features.find(
//           (f) => f.properties.ADM_Code === code
//         )?.properties.ADM1 || code;
//         return { municipality, riskLevel: riskT[data.riskLevel], probability: data.probability };
//       })
//       .sort((a, b) => {
//         const riskPriority = {
//           [riskT['Very High Risk']]: 3,
//           [riskT['High Risk']]: 2,
//           [riskT['Moderate Risk']]: 1
//         };
//         const priorityA = riskPriority[a.riskLevel] || 0;
//         const priorityB = riskPriority[b.riskLevel] || 0;
//         return priorityB - priorityA || b.probability - a.probability;
//       })
//       .map(data => [data.municipality, data.riskLevel, data.probability]);

//     // Add table
//     if (currentY + 20 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     autoTable(pdf, {
//       startY: currentY,
//       head: [t.tableHeaders],
//       body: tableData,
//       theme: 'grid',
//       headStyles: { fillColor: [225, 232, 242], halign: 'left', fontStyle: 'bold',textColor: 'black' },
//       styles: { fontSize: 9, cellPadding: 3 },
//       columnStyles: {
//         0: { cellWidth: 60 },
//         1: { cellWidth: 60 },
//         2: { cellWidth: 40 },
//       },
//       margin: { left: sideMargin, right: sideMargin, top: headerHeight },
//       willDrawPage: (data) => {
//         data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//       },
//       didDrawPage: (data) => {
//         currentY = data.cursor.y + 10;
//       },
//     });
//     currentY += 5;

//     // GENERAL ADVISORY section
//     if (currentY + 10 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(12);
//     pdf.setFont('helvetica', 'bold');
//     pdf.setFillColor(202, 217, 239);
//     pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, 'F');
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(t.generalAdvisory, sideMargin + 2, currentY - 1, { align: 'left' });
//     pdf.setTextColor(0, 0, 0);
//     currentY += 7;

//     // Advisory intro
//     pdf.setFontSize(10);
//     pdf.setFont('helvetica', 'normal');
//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     const introLines = pdf.splitTextToSize(t.advisoryIntro, pageWidth - 2 * sideMargin);
//     introLines.forEach(line => {
//       if (currentY + 6 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }
//       pdf.text(line, sideMargin, currentY);
//       currentY += 6;
//     });
//     currentY += 5;

//     // Advisory table from translations
//     const advisoryTableData = t.advisoryPoints.map(category => [
//       category.type,
//       category.points.map(point => `• ${point}`).join('\n')
//     ]);
//     if (currentY + 20 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     autoTable(pdf, {
//       startY: currentY,
//       head: [t.advisoryTableHeaders],
//       body: advisoryTableData,
//       theme: 'grid',
//       headStyles: {
//         fillColor: [225, 232, 242],
//         halign: 'left',
//         fontStyle: 'bold',
//         textColor: 'black',
//       },
//       styles: {
//         fontSize: 9,
//         cellPadding: { top: 3, right: 3, bottom: 3, left: 5 },
//         overflow: 'linebreak',
//         lineHeight: 1.2,
//       },
//       columnStyles: {
//         0: { cellWidth: 40, halign: 'left' },
//         1: { cellWidth: pageWidth - 2 * sideMargin - 40, halign: 'left' },
//       },
//       margin: { left: sideMargin, right: sideMargin, top: headerHeight },
//       willDrawPage: (data) => {
//         data.settings.startY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
//       },
//       didDrawPage: (data) => {
//         currentY = data.cursor.y + 10;
//       },
//     });
//     currentY += 5;

//     // Add Note section
//     if (currentY + 12 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFontSize(10);
//     pdf.setFont('helvetica', 'bold');
//     pdf.text(t.noteLabel, sideMargin, currentY);
//     currentY += 6;
//     pdf.setFont('helvetica', 'normal');
//     const noteLines = pdf.splitTextToSize(t.noteText, pageWidth - 2 * sideMargin);
//     noteLines.forEach(line => {
//       if (currentY + 6 > availablePageHeight + headerHeight) {
//         currentY = addPageWithHeader();
//       }
//       pdf.text(line, sideMargin, currentY);
//       currentY += 6;
//     });
//     currentY += 4;

//     currentY += 12;

//     if (currentY + 6 > availablePageHeight + headerHeight) {
//       currentY = addPageWithHeader();
//     }
//     pdf.setFont('helvetica', 'bold');
//     pdf.text('*****', (pageWidth - pdf.getTextWidth('*****')) / 2, currentY);
//     currentY += 6;
//     pdf.setFont('helvetica', 'normal');

//     // Add footer to all pages
//     const pageCount = pdf.internal.getNumberOfPages();
//     const footerYOffset = 5;
//     for (let i = 1; i <= pageCount; i++) {
//       pdf.setPage(i);
//       pdf.setFontSize(8);
//       pdf.text(
//         t.footer,
//         pageWidth / 2,
//         pageHeight - footerHeight + footerYOffset - 2,
//         { align: 'center' }
//       );
//       pdf.text(
//         t.page.replace('[i]', i).replace('[pageCount]', pageCount),
//         pageWidth / 2,
//         pageHeight - footerHeight + footerYOffset + 3,
//         { align: 'center' }
//       );
//     }

//     pdf.save('DRRDSS-Lightning-Advisory.pdf');
//   } catch (error) {
//     console.error('Failed to generate PDF:', error);
//     throw error;
//   }
// };

// // info i button

// const InfoButton = ({ setInfo }) => {
//   useMap(); // Optional: only needed if you want to interact with the map
//   return (
//     <div
//       style={{
//         position: "absolute",
//         bottom: "10px",
//         left: "10px",
//         padding: "8px",
//         borderRadius: "5px",
//         fontSize: "15px",
//         cursor: "pointer",
//         zIndex: 999,
//       }}
//       onMouseEnter={() => setInfo(true)}
//       onMouseLeave={() => setInfo(false)}
//     >
//       <FaCircleInfo />
//     </div>
//   );
// };

// const Lightningsuco = () => {
//   const [geoData, setGeoData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [info, setInfo] = useState(false);
//   const containerRef = useRef(null);

//   // Fetch GeoJSON data
//   useEffect(() => {
//     fetch('/DATA/OSMbased_adm1_boundary.json')
//       .then((response) => response.json())
//       .then((data) => setGeoData(data))
//       .catch((error) => console.error('Error fetching GeoJSON:', error));
//   }, []);

//   // Style for each GeoJSON feature
//   const styleFeature = (feature) => {
//     const admCode = feature.properties.ADM_Code;
//     const probability = riskData[admCode]?.probability || 0;
//     return {
//       fillColor: getColor(probability),
//       weight: 1,
//       opacity: 1,
//       color: 'black',
//       fillOpacity: 1,
//     };
//   };

//   // Handle click event for each feature
//   const onEachFeature = (feature, layer) => {
//     const admCode = feature.properties.ADM_Code;
//     const municipality = feature.properties.ADM1;
//     const riskInfo = riskData[admCode] || { probability: 0, riskLevel: 'Low Risk' };

//     layer.on({
//       click: () => {
//         layer.bindPopup(`
//           <div>
//             <b>${municipality}</b><br/>
//             Lightning Impact: <strong>${riskInfo.riskLevel}</strong><br/>
//             Probability: <strong>${riskInfo.probability}</strong>
//           </div>
//         `).openPopup();
//       },
//     });
//   };

//   // Calculate center of a GeoJSON feature for label placement
//   const getFeatureCenter = (feature) => {
//     const coordinates = feature.geometry.coordinates;
//     let latSum = 0, lngSum = 0, count = 0;

//     const processCoordinates = (coords) => {
//       coords.forEach(coord => {
//         if (Array.isArray(coord[0])) {
//           processCoordinates(coord);
//         } else {
//           latSum += coord[1];
//           lngSum += coord[0];
//           count++;
//         }
//       });
//     };

//     if (feature.geometry.type === 'Polygon') {
//       processCoordinates(coordinates[0]);
//     } else if (feature.geometry.type === 'MultiPolygon') {
//       coordinates.forEach(polygon => processCoordinates(polygon[0]));
//     }

//     return [latSum / count, lngSum / count];
//   };

//   // Generate report with language selection
//   // const generateReport = async () => {
//   //   const containerElement = containerRef.current;
//   //   if (!containerElement || !geoData) {
//   //     console.warn('Cannot generate report: container or geoData missing');
//   //     return;
//   //   }

//   //   // Prompt user to select language
//   //   const languagePrompt = window.prompt(
//   //     'Please select the language for Generating Report:\nOption 1: English\nOption 2: Tetum\n\nEnter 1 for English or 2 for Tetum:',
//   //     '1'
//   //   );

//   //   let language = 'en';
//   //   if (languagePrompt === '2') {
//   //     language = 'tetum';
//   //   } else if (languagePrompt !== '1') {
//   //     alert('Invalid selection. Defaulting to English.');
//   //   }

//   //   setLoading(true);
//   //   try {
//   //     const dataUrl = await domtoimage.toPng(containerElement, {
//   //       width: containerElement.offsetWidth,
//   //       height: containerElement.offsetHeight,
//   //       style: { background: 'white' },
//   //       quality: 0.95,
//   //     });
//   //     await generatePdfWithImage(dataUrl, geoData, language);
//   //   } catch (error) {
//   //     console.error('Failed to capture image or generate PDF:', error);
//   //     alert('Failed to generate PDF. Please try again.');
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
  
//   const generateReport = async () => {
//     const containerElement = containerRef.current;
//     if (!containerElement || !geoData) {
//       console.warn('Cannot generate report: container or geoData missing');
//       return;
//     }

//     // Create a popup for language selection
//     const languageSelection = await new Promise((resolve) => {
//       const popup = document.createElement('div');
//       popup.style.position = 'fixed';
//       popup.style.top = '50%';
//       popup.style.left = '50%';
//       popup.style.transform = 'translate(-50%, -50%)';
//       popup.style.background = 'white';
//       popup.style.padding = '20px';
//       popup.style.border = '1px solid #ccc';
//       popup.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
//       popup.style.zIndex = '1000';
//       popup.style.textAlign = 'center';
//       popup.style.fontFamily = 'Arial, sans-serif';
//       popup.style.borderRadius = '8px';
//       popup.style.minWidth = '250px';

//       popup.innerHTML = `
//       <button id="closeBtn" style="background: none; border: none; font-size: 12px; margin-left:99%; cursor: pointer;">✖</button>
//         <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
//           <h3 style="margin: 0; font-size: 12px;">Choose language to generate advisory</h3>
          
//         </div>
//         <button id="englishBtn" style="margin: 5px; padding: 8px 16px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">English</button>
//         <button id="tetumBtn" style="margin: 5px; padding: 8px 16px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">Tetum</button>
//       `;

//       document.body.appendChild(popup);

//       const removePopup = () => {
//         document.body.removeChild(popup);
//       };

//       document.getElementById('englishBtn').addEventListener('click', () => {
//         removePopup();
//         resolve('en');
//       });

//       document.getElementById('tetumBtn').addEventListener('click', () => {
//         removePopup();
//         resolve('tetum');
//       });

//       document.getElementById('closeBtn').addEventListener('click', () => {
//         removePopup();
//         resolve(null);
//       });
//     });

//     // If popup is closed or no language is selected, exit without generating PDF
//     if (!languageSelection) {
//       return;
//     }

//     setLoading(true);
//     try {
//       const dataUrl = await domtoimage.toPng(containerElement, {
//         width: containerElement.offsetWidth,
//         height: containerElement.offsetHeight,
//         style: { background: 'white' },
//         quality: 0.95,
//       });
//       await generatePdfWithImage(dataUrl, geoData, languageSelection);
//     } catch (error) {
//       console.error('Failed to capture image or generate PDF:', error);
//       alert('Failed to generate PDF. Please try again.');
//     } finally {
//       setLoading(false);
//     }
// };

//   return (
//     <>
//       <button
//         onClick={generateReport}
//         disabled={loading}
//         className={`px-2 py-1 rounded hover:bg-blue-600 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
//         style={{ backgroundColor: 'blue', color: 'white', marginLeft: '85%', marginBottom:'5px',position: 'absolute',
//           top: '120px',
//           right: '10px', zIndex: 900, border:'none' }}
//       >
//         {loading ? 'Generating...' : 'Generate Report'}
//       </button>
//       <div ref={containerRef} className="relative h-screen w-full">
//         <MapContainer
//           center={[-9.0, 125.6]}
//           zoom={8}
//           style={{ height: '78vh', width: '100%', backgroundColor: 'white' }}
//         >
//           <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//           {geoData && (
//             <GeoJSON
//               data={geoData}
//               style={styleFeature}
//               onEachFeature={onEachFeature}
//             />
//           )}
//           {geoData &&
//             geoData.features.map((feature, index) => {
//               const center = getFeatureCenter(feature);
//               const municipality = feature.properties.ADM1;

//               return (
//                 <Marker
//                   key={index}
//                   position={center}
//                   icon={L.divIcon({
//                     className: 'custom-label',
//                     html: `<div style="color: black; font-size: 12px; text-align: center; white-space: nowrap;">${municipality}</div>`,
//                     iconSize: [100, 20],
//                     iconAnchor: [50, 10],
//                   })}
//                   interactive={false}
//                 />
//               );
//             })}
//              <div
//           style={{
//             position: 'absolute',
//             bottom: '0px',
//             right: '0px',
//             background: 'white',
//             padding: '10px',
//             border: '1px solid #ccc',
//             zIndex: 1000,
//           }}
//         >
//           <LegendItem color="rgb(22, 198, 9)" label="Low Risk (0-0.2)" />
//           <LegendItem color="rgb(255, 240, 0)" label="Moderate Risk (0.2-0.5)" />
//           <LegendItem color="rgb(246, 99, 12)" label="High Risk (0.5-0.8)" />
//           <LegendItem color="rgb(232, 19, 36)" label="Very High Risk (0.8-1)" />
//         </div>

//         {info && (
//               <div
//                 style={{
//                   position: "absolute",
//                   bottom: "13px",
//                   left: "35px",
//                   fontSize: "12px",
//                   zIndex: 1000,
//                   backgroundColor: "white",
//                   padding: "5px",
//                   borderRadius: "5px",
//                   boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//                 }}
//               >
//                 Lightning flash probability valid for next 24 hours
//               </div>
//             )}
//             <InfoButton setInfo={setInfo} />

//         </MapContainer>
//         {/* <div
//           style={{
//             position: 'absolute',
//             bottom: '15px',
//             right: '10px',
//             background: 'white',
//             padding: '10px',
//             border: '1px solid #ccc',
//             zIndex: 1000,
//           }}
//         >
//           <LegendItem color="rgba(0, 255, 0, 1)" label="Low Risk (0-0.2)" />
//           <LegendItem color="rgba(255, 255, 0, 1)" label="Moderate Risk (0.2-0.5)" />
//           <LegendItem color="rgba(255, 165, 0, 1)" label="High Risk (0.5-0.8)" />
//           <LegendItem color="rgba(255, 0, 0, 1)" label="Very High Risk (0.8-1)" />
//         </div> */}
//       </div>
//       {/* <Cape/> */}
//     </>
//   );
// };

// const LegendItem = ({ color, label }) => (
//   <div style={{ marginBottom: '5px' }}>
//     <span
//       style={{
//         display: 'inline-block',
//         width: '20px',
//         height: '10px',
//         background: color,
//         marginRight: '5px',
//       }}
//     ></span>
//     {label}
//   </div>
// );

// export default Lightningsuco;



import React, { useEffect, useState, useRef } from "react";
import { MapContainer, TileLayer, GeoJSON, useMap } from "react-leaflet";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { FaCircleInfo } from "react-icons/fa6";
import "leaflet/dist/leaflet.css";
import { Modal } from "react-bootstrap";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import domtoimage from "dom-to-image-more";
import axios from 'axios';
import moment from "moment-timezone";
import { translations, riskTranslations } from "./Translations_Lightning.js";
import ImpactedAreaLightning from "./ImpactedArea_Lightning.js";
import { MapHomeControl } from "../../../common/MapControls/MapControls";

const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;

const INITIAL_VIEW = {
  lat: -8.8742,
  lng: 125.7275,
  zoom: 8,
};

const mapAdvisoryToRiskLevel = (advisoryText) => {
  if (!advisoryText) return 'Low';
  const cleanText = advisoryText.trim();
  if (cleanText === 'Very high') return 'Very High';
  if (cleanText === 'High') return 'High';
  if (cleanText === 'Moderate') return 'Moderate';
  if (cleanText === 'Low') return 'Low';
  return 'Low';
};

const fetchAllForecastData = async () => {
  try {
    const [statsResponse, munisResponse, subMunisResponse] = await Promise.all([
      axios.get(`${backendUrl}lightning/lightning-forecast/`),
      axios.post(`${backendUrl}Municipalities/municipalities_list/`),
      axios.post(`${backendUrl}Municipalities/sub_municipalities_list/`),
    ]);

    const statsData = statsResponse.data;
    const currentDate = moment.tz('Asia/Dili').format('YYYYMMDD');
    const dateHrs = [
      `${currentDate}_00hr`,
      `${currentDate}_06hr`,
      `${currentDate}_12hr`,
      `${currentDate}_18hr`
    ];
    const filteredStats = statsData.filter(item => dateHrs.includes(item.date_hr));

    const munisData = munisResponse.data;
    const subMunisData = subMunisResponse.data;

    const muniMap = new Map(munisData.map(m => [m.adm1_code, m.adm1]));
    const subMuniMap = new Map(subMunisData.map(s => [s.adm2_code, s.adm2]));

    const processedData = {};
    const uniqueAdmCodes = [...new Set(filteredStats.map(item => item.admcode))];

    uniqueAdmCodes.forEach(admcode => {
      const adm1Code = admcode.substring(0, 4);
      processedData[admcode] = {
        Municipality: muniMap.get(adm1Code) || 'Unknown',
        PostAdmin: subMuniMap.get(admcode) || 'Unknown',
      };
      dateHrs.forEach(dateHr => {
        const hr = dateHr.split('_')[1];
        processedData[admcode][`Advisory_${hr}`] = 'Low';
      });
    });

    filteredStats.forEach(item => {
      const admcode = item.admcode;
      const hr = item.date_hr.split('_')[1];
      if (processedData[admcode]) {
        processedData[admcode][`Advisory_${hr}`] = mapAdvisoryToRiskLevel(item.advisory);
      }
    });

    const finalData = Object.values(processedData).map((item, index) => ({...item, SlNo: index + 1})).sort((a, b) => a.SlNo - b.SlNo);

    const fullStatsGrouped = filteredStats.reduce((acc, item) => {
      if (!acc[item.admcode]) acc[item.admcode] = {};
      acc[item.admcode][item.date_hr] = item;
      return acc;
    }, {});

    return { data: finalData, error: null, fullStatsData: fullStatsGrouped, dateHrs: dateHrs, munisData, subMunisData };
  } catch (error) {
    console.error("Failed to fetch data:", error);
    return { data: [], error: error.message, fullStatsData: {}, dateHrs: [], munisData: [], subMunisData: [] };
  }
};

const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous"; // Handle CORS for external images
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
    img.src = src;
  });
};

const addBanner = (pdf, bannerImage, sideMargin, topMargin, pageWidth) => {
  const bannerHeight = 20;
  const bannerWidth = pageWidth - 2 * sideMargin;
  if (bannerImage) {
    pdf.addImage(bannerImage, "PNG", sideMargin, topMargin, bannerWidth, bannerHeight);
  }
  return topMargin + bannerHeight + 5;
};

const getDynamicWarningTitle = (municipalities, language) => {
  const geoName = "Timor-Leste";
  const geoLevel = language === 'tetum' ? 'Nasaun' : 'Country';
  const advisoryType = language === 'tetum' ? 'Aviso kona-ba Rai-hukar' : 'Lightning Advisory';
  return language === 'tetum' && geoLevel === 'Nasaun' ? `${advisoryType} iha ${geoName}` : `${advisoryType} for ${geoName} (${geoLevel})`;
};

const drawLegend = (pdf, currentY, sideMargin, riskT) => {
  const legendWidth = 30;
  const legendHeight = 5;
  const legendGap = 5;
  const textOffset = 5;

  const risks = ['Low', 'Moderate', 'High', 'Very High'];
  const colors = {
    'Low': [83, 133, 25],
    'Moderate': [243, 235, 18],
    'High': [243, 155, 58],
    'Very High': [230, 45, 58]
  };

  risks.forEach((risk, index) => {
    pdf.setFillColor(...colors[risk]);
    pdf.rect(sideMargin, currentY + index * (legendHeight + legendGap), legendWidth, legendHeight, 'F');
    pdf.setTextColor(0, 0, 0);
    const riskText = riskT[risk] || risk;
    pdf.text(riskText, sideMargin + legendWidth + textOffset, currentY + index * (legendHeight + legendGap) + legendHeight / 2 + 1);
  });

  return currentY + risks.length * (legendHeight + legendGap) + 5;
};

const BoundaryLayer = ({ boundaryData, dateHr, fullStatsData }) => {
  const map = useMap();
  useEffect(() => {
    map.invalidateSize(); // Ensure map is fully rendered
  }, [map]);

  if (!boundaryData) return null;

  const getStyle = (feature) => {
    const admcode = feature.properties.ADM_Code;
    const entry = fullStatsData[admcode] ? fullStatsData[admcode][dateHr] : null;
    const density = entry ? entry.lightningflashdensity : 0;
    let fillColor = 'rgb(83, 133, 25)'; // Low
    if (density >= 1 && density < 2) fillColor = 'rgb(243, 235, 18)'; // Moderate
    else if (density >= 2 && density < 3) fillColor = 'rgb(243, 155, 58)'; // High
    else if (density >= 3) fillColor = 'rgb(230, 45, 58)'; // Very High

    return {
      fillColor,
      fillOpacity: 1,
      color: 'black',
      weight: 1,
      opacity: 1
    };
  };

  return (
    <GeoJSON
      key={`lightning-${dateHr}`}
      data={boundaryData}
      style={getStyle}
      onEachFeature={(feature, layer) => {
        const admcode = feature.properties.ADM_Code;
        const entry = fullStatsData[admcode] ? fullStatsData[admcode][dateHr] : null;
        let popupContent = `Post Admin: ${feature.properties.ADM2 || 'Unknown'}<br>Municipality: ${feature.properties.ADM1}<br>Date Hr: ${dateHr}`;
        if (entry) {
          popupContent += `<br>Advisory: ${entry.advisory}<br>Density: ${entry.lightningflashdensity}<br>Precipitation: ${entry.precipitation}<br>CAPE: ${entry.cape}`;
        } else {
          popupContent += '<br>No data';
        }
        layer.bindPopup(popupContent);
      }}
    />
  );
};

const Lightningsuco = () => {
  const [loading, setLoading] = useState(false);
  const [adm2Data, setAdm2Data] = useState(null);
  const [lightningTableData, setLightningTableData] = useState([]);
  const [fullLightningData, setFullLightningData] = useState([]);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const mapsRef = useRef(null);
  const tableRef = useRef(null);
  const [, setPdfLanguage] = useState("en");
  const [isDataReady, setIsDataReady] = useState(false);
  const [municipalities, setMunicipalities] = useState([]);
  const [dateHrs, setDateHrs] = useState([]);

  useEffect(() => {
    const initializeData = async () => {
      setLoading(true);
      try {
        const lightningDataResp = await fetchAllForecastData();
        const { data, fullStatsData, dateHrs: hrs, munisData } = lightningDataResp;

        const subMunicipalityGeo = await fetch("/DATA/OSMbased_adm2_boundary.json").then((res) => res.json());
        
        setAdm2Data(subMunicipalityGeo);
        setMunicipalities(munisData);
        setLightningTableData(data);
        setFullLightningData(fullStatsData);
        setDateHrs(hrs);
        setIsDataReady(true);
      } catch (error) {
        console.error("Error loading initial data:", error);
        setIsDataReady(false);
      } finally {
        setLoading(false);
      }
    };

    initializeData();
  }, []);

  const handleGenerateReportClick = () => {
    if (!isDataReady || !mapsRef.current) {
      alert("Please wait until all data is loaded and maps are rendered.");
      return;
    }
    setShowLanguageModal(true);
  };

  const handleLanguageSelectAndGenerate = async (selectedLanguage) => {
    setShowLanguageModal(false);
    setPdfLanguage(selectedLanguage);
    await captureAndGeneratePdf(selectedLanguage);
  };

  const captureAndGeneratePdf = async (language) => {
    setLoading(true);
    try {
      const pdf = new jsPDF("portrait", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const sideMargin = 10;
      const topMargin = 10;
      const footerHeight = 10;
      const marginBottom = 10;
      const headerHeight = topMargin + 20 + 5;
      const availablePageHeight = pageHeight - headerHeight - footerHeight - marginBottom;
      let currentY;

      const t = translations[language] || translations['en']; // Fallback to English if language not found
      const riskT = riskTranslations[language] || riskTranslations['en'];

      const dynamicTitle = getDynamicWarningTitle(municipalities, language);
      const now = moment.tz("Asia/Dili").format("YYYY-MM-DD HH:mm:ss A") + " East Timor Time (TLT)";

      let bannerImage;
      try {
        const bannerPath = language === "en" ? "/pdf/banner.png" : "/pdf/tetumbanner.png";
        bannerImage = await loadImage(bannerPath);
      } catch (error) {
        console.warn("Failed to load banner image, proceeding without it:", error);
        bannerImage = null;
      }

      const addPageWithHeader = () => {
        pdf.addPage();
        currentY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
        return currentY + 5;
      };

      const safeText = (text, x, y, options = {}) => {
        if (typeof text !== 'string' && !Array.isArray(text)) {
          console.error(`Invalid text argument at (${x}, ${y}):`, text);
          return;
        }
        if (isNaN(x) || isNaN(y)) {
          console.error(`Invalid coordinates at (${x}, ${y}) for text:`, text);
          return;
        }
        try {
          pdf.text(text, x, y, options);
        } catch (error) {
          console.error(`Error rendering text "${text}" at (${x}, ${y}):`, error);
        }
      };

      currentY = addBanner(pdf, bannerImage, sideMargin, topMargin, pageWidth);
      currentY += 5;

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      safeText(dynamicTitle || "Lightning Advisory", pageWidth / 2, currentY, { align: "center" });
      pdf.setFont("helvetica", "normal");
      currentY += 10;

      pdf.setFontSize(10);
      pdf.setFont("helvetica", "bold");
      const advisoryNumber = t.advisoryNumber || "Advisory number: ";
      safeText(advisoryNumber, sideMargin, currentY);
      pdf.setFont("helvetica", "normal");
      safeText("1", sideMargin + pdf.getTextWidth(advisoryNumber) + 2, currentY);
      pdf.setFont("helvetica", "bold");
      const issuedAtLabel = t.issuedAt || "Date & Time: ";
      const rightText = `${issuedAtLabel}${now}`;
      const rightTextWidth = pdf.getTextWidth(rightText);
      const rightX = pageWidth - sideMargin - rightTextWidth;
      safeText(issuedAtLabel, rightX, currentY);
      pdf.setFont("helvetica", "normal");
      safeText(now, rightX + pdf.getTextWidth(issuedAtLabel) + 2, currentY);
      currentY += 12;

      pdf.setFont("helvetica", "bold");
      const issuedByLabel = t.issuedBy || "Issued by: ";
      safeText(issuedByLabel, sideMargin, currentY);
      pdf.setFont("helvetica", "normal");
      safeText("National Directorate of Meteorology and Geophysics", sideMargin + pdf.getTextWidth(issuedByLabel) + 2, currentY);
      currentY += 6;
      currentY += 5;

      const muniRisk = {};
      Object.entries(fullLightningData).forEach(([admcode, dates]) => {
        const adm1Code = admcode.substring(0, 4);
        if (!muniRisk[adm1Code]) muniRisk[adm1Code] = { maxDensity: 0 };
        Object.values(dates).forEach(item => {
          const density = item.lightningflashdensity;
          if (density > muniRisk[adm1Code].maxDensity) muniRisk[adm1Code].maxDensity = density;
        });
      });

      const highRiskMunicipalities = Object.entries(muniRisk)
        .filter(([_, { maxDensity }]) => maxDensity >= 2)
        .map(([adm1Code]) => municipalities.find(m => m.adm1_code === adm1Code)?.adm1 || adm1Code)
        .join(', ') || 'no areas';

      const moderateRiskMunicipalities = Object.entries(muniRisk)
        .filter(([_, { maxDensity }]) => maxDensity >= 1 && maxDensity < 2)
        .map(([adm1Code]) => municipalities.find(m => m.adm1_code === adm1Code)?.adm1 || adm1Code)
        .join(', ') || 'no areas';

      pdf.setFontSize(12);
      pdf.setFont("helvetica", "bold");
      pdf.setFillColor(202, 217, 239);
      pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F");
      safeText(t.overview || "Overview:", sideMargin + 2, currentY - 2, { align: "left" });
      pdf.setTextColor(0, 0, 0);
      currentY += 5;

      pdf.setFontSize(10);
      pdf.setFont("helvetica", "normal");
      const overviewText = `${t.highRiskWarningPart1 || "A forecast has been issued for high lightning risk hotspots in several post admins within [highRiskAreas]. Immediate precautions are recommended to prevent lightning incidents."}`.replace('[highRiskAreas]', highRiskMunicipalities) + ' ' +
        `${t.moderateRiskWarning || "Moderate risk of lightning activity is expected in [moderateRiskAreas]."}`.replace('[moderateRiskAreas]', moderateRiskMunicipalities) + ' ' +
        (t.highRiskWarningPart2 || "There may be temporary localized strong winds during thundershowers. The general public is kindly requested to take adequate precautions to minimize damages caused by lightning activity.");
      const textLines = pdf.splitTextToSize(overviewText, pageWidth - 2 * sideMargin);
      textLines.forEach(line => {
        safeText(line, sideMargin, currentY);
        currentY += 5;
      });
      currentY += 2;

      if (mapsRef.current) {
        try {
          const mapBlob = await domtoimage.toBlob(mapsRef.current, {
            width: 1330,
            height: mapsRef.current.offsetHeight,
            style: { background: "white" },
            quality: 0.95,
          });
          const mapUrl = URL.createObjectURL(mapBlob);
          const mapImg = await loadImage(mapUrl);
          const availableWidth = pageWidth - 2 * sideMargin;
          const actualMapHeight = (mapImg.height * availableWidth) / mapImg.width;

          if (currentY + 10 + actualMapHeight + 5 > availablePageHeight + headerHeight) {
            currentY = addPageWithHeader();
          }

          pdf.addImage(mapUrl, "PNG", sideMargin, currentY, availableWidth, actualMapHeight);
          currentY += actualMapHeight + 5;
          URL.revokeObjectURL(mapUrl);
        } catch (error) {
          console.error("Failed to capture maps:", error);
          throw new Error("Unable to capture map content for PDF.");
        }
      } else {
        console.warn("No lightning maps provided for PDF");
        throw new Error("Map container is not available.");
      }

      currentY = drawLegend(pdf, currentY, sideMargin, riskT);

      const tableDataForPdf = lightningTableData.map(item => [
        item.SlNo,
        item.Municipality,
        item.PostAdmin,
        ...dateHrs.map(dateHr => {
          const hr = dateHr.split('_')[1];
          return item[`Advisory_${hr}`] || 'N/A';
        })
      ]);

      const estimatedTableHeight = tableDataForPdf.length * 8 + 15;
      if (currentY + 10 + estimatedTableHeight + 10 > availablePageHeight + headerHeight) {
        currentY = addPageWithHeader();
      }

      currentY += 10;
      pdf.setFontSize(12);
      pdf.setFont("helvetica", "bold");
      pdf.setFillColor(202, 217, 239);
      pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F");
      safeText(t.impact || "Impact and Risk Information:", sideMargin + 2, currentY - 2, { align: "left" });
      pdf.setTextColor(0, 0, 0);
      currentY += 5;

      autoTable(pdf, {
        startY: currentY,
        head: [['S.No', 'Municipality', 'Post Administrative', ...dateHrs.map(dateHr => `Advisory (${dateHr.replace('_', ' ')})`)]],
        body: tableDataForPdf,
        theme: "grid",
        headStyles: {
          fillColor: [225, 232, 242],
          halign: "center",
          fontStyle: "bold",
          textColor: "black",
        },
        styles: {
          fontSize: 8,
          cellPadding: 2,
          overflow: "linebreak",
          lineWidth: 0.1,
          lineColor: [150, 150, 150],
        },
        margin: { left: sideMargin, right: sideMargin, top: headerHeight },
        didDrawPage: (data) => {
          currentY = data.cursor.y + 10;
        },
      });

      currentY = pdf.lastAutoTable.finalY + 5;

      const advisoryTableData = (t.advisoryPoints || []).map(item => [
        item.type || '',
        item.points ? item.points.join("\n") : ''
      ]);

      let estimatedAdvisoryTableHeight = advisoryTableData.reduce((height, row) => height + (row[1].split("\n").length * 6 + 10), 15);

      if (currentY + 10 + estimatedAdvisoryTableHeight + 10 > availablePageHeight + headerHeight) {
        currentY = addPageWithHeader();
      }
      currentY += 10;
      pdf.setFontSize(12);
      pdf.setFont("helvetica", "bold");
      pdf.setFillColor(202, 217, 239);
      pdf.rect(sideMargin, currentY - 8, pageWidth - 2 * sideMargin, 10, "F");
      safeText(t.generalAdvisory || "General Advisory:", sideMargin + 2, currentY - 2, { align: "left" });
      pdf.setTextColor(0, 0, 0);
      currentY += 7;

      autoTable(pdf, {
        startY: currentY,
        head: [t.advisoryTableHeaders || ["Type", "Advisory"]],
        body: advisoryTableData,
        theme: "grid",
        headStyles: {
          fillColor: [225, 232, 242],
          halign: "left",
          fontStyle: "bold",
          textColor: "black",
        },
        styles: {
          fontSize: 9,
          cellPadding: { top: 3, right: 3, bottom: 3, left: 5 },
          overflow: "linebreak",
          lineHeight: 1.2,
        },
        columnStyles: {
          0: { cellWidth: 'auto', halign: "left" },
          1: { cellWidth: pageWidth - 2 * sideMargin - 60, halign: "left" },
        },
        margin: { left: sideMargin, right: sideMargin, top: headerHeight },
        didDrawPage: (data) => {
          currentY = data.cursor.y + 10;
        },
      });
      currentY = pdf.lastAutoTable.finalY + 5;

      const noteText = (t.noteText || "The report is valid for the next 24 hours. Please monitor the website for additional information and alerts issued by the Department of Meteorology.").trim().replace(/\s+/g, ' ');
      const noteTextLines = pdf.splitTextToSize(noteText, pageWidth - 2 * sideMargin);
      const estimatedNoteHeight = noteTextLines.length * 6 + 12;

      if (currentY + estimatedNoteHeight > availablePageHeight + headerHeight) {
        currentY = addPageWithHeader();
      }
      pdf.setFontSize(10);
      pdf.setFont("helvetica", "bold");
      safeText(t.noteLabel || "Note:", sideMargin, currentY);
      currentY += 6;
      pdf.setFont("helvetica", "normal");
      noteTextLines.forEach((line) => {
        if (currentY + 6 > availablePageHeight + headerHeight) {
          currentY = addPageWithHeader();
        }
        safeText(line, sideMargin, currentY);
        currentY += 6;
      });
      pdf.setFont("helvetica", "bold");
      safeText("*****", (pageWidth - pdf.getTextWidth("*****")) / 2, currentY);
      currentY += 6;

      const pageCount = pdf.internal.getNumberOfPages();
      const footerYOffset = 5;
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(8);
        safeText(t.footer || "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986", 
                 pageWidth / 2, pageHeight - footerHeight + footerYOffset - 2, { align: "center" });
        safeText(t.page.replace("[i]", i).replace("[pageCount]", pageCount) || `Page ${i} of ${pageCount}`, 
                 pageWidth / 2, pageHeight - footerYOffset + footerYOffset + 3, { align: "center" });
      }

      pdf.save("DRRDSS-Lightning-Advisory.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate PDF: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: '100%', mx: 'auto', p: 2, bgcolor: '#f8f9fa' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button
          variant="contained"
          startIcon={<DescriptionIcon />}
          onClick={handleGenerateReportClick}
          disabled={loading}
          sx={{
            backgroundColor: '#0d6efd',
            '&:hover': { backgroundColor: '#0b5ed7' },
            textTransform: 'none',
            fontWeight: 'bold',
            px: 3,
            py: 1,
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Generate Report'}
        </Button>
      </Box>
      <Box ref={mapsRef}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5, px: 0.5 }}>
          <FaCircleInfo size={14} color="#0d6efd" />
          <Box component="span" sx={{ fontSize: '12.5px', color: '#555' }}>
            Lightning potential forecast tiles by date/hour (Open-Meteo JMA model). Each tile can be reset to its initial view using the home button on its map.
          </Box>
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, mb: 2 }}>
          {dateHrs.map(dateHr => (
            <Box key={dateHr} sx={{ position: 'relative' }}>
              <MapContainer
                center={[INITIAL_VIEW.lat, INITIAL_VIEW.lng]}
                zoom={INITIAL_VIEW.zoom}
                style={{ height: '300px', width: '100%' }}
              >
                <MapHomeControl />
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                />
                {adm2Data && (
                  <BoundaryLayer
                    boundaryData={adm2Data}
                    dateHr={dateHr}
                    fullStatsData={fullLightningData}
                  />
                )}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 10,
                    right: 25,
                    zIndex: 400,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                  }}
                >
                  {dateHr.replace('_', ' ')}
                </Box>
              </MapContainer>
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 2,
            p: 1,
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          }}
        >
          <Typography variant="subtitle2" sx={{ mr: 2, fontWeight: 'bold' }}>
            Lightning Flash Density:
          </Typography>
          {[
            { label: 'Low (0-1)', color: 'rgb(83, 133, 25)' },
            { label: 'Moderate (1-2)', color: 'rgb(243, 235, 18)' },
            { label: 'High (2-3)', color: 'rgb(243, 155, 58)' },
            { label: 'Very High (3+)', color: 'rgb(230, 45, 58)' },
          ].map((item, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
              <Box sx={{ width: 20, height: 10, backgroundColor: item.color, mr: 1 }} />
              <Typography variant="body2">{item.label}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <Box ref={tableRef}>
        <ImpactedAreaLightning
          loading={loading}
          tableData={lightningTableData}
          municipalities={municipalities}
          dateHrs={dateHrs}
        />
      </Box>
      <Modal
        show={showLanguageModal}
        onHide={() => setShowLanguageModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Report Language</Modal.Title>
        </Modal.Header>
        <Modal.Body sx={{ textAlign: 'center' }}>
          <Button variant="contained" onClick={() => handleLanguageSelectAndGenerate("en")} sx={{ mr: 2, bgcolor: '#0d6efd', '&:hover': { bgcolor: '#0b5ed7' } }}>
            English
          </Button>
          <Button variant="contained" onClick={() => handleLanguageSelectAndGenerate("tetum")} sx={{ bgcolor: '#28a745', '&:hover': { bgcolor: '#218838' } }}>
            Tetum
          </Button>
        </Modal.Body>
      </Modal>
    </Box>
  );
};

export default Lightningsuco;
